// src/api/under-nav/likes.ts
import { api } from "../client";

function un(res: any) {
    return res?.data?.data ?? res?.data ?? res;
}

export interface LikeItem {
    id: string;
    name: string;
    image: string;
    age: number;
    distance: number;
    superliked_me: boolean;
    is_online: boolean;
    like_date: string;
    isLoaded?: boolean;
}

export interface LikesResponse {
    items: LikeItem[];
    total?: number;
    has_more?: boolean;
}

// нормализация фото
function normalizeLike(u: any): LikeItem {
    return {
        ...u,
        image: u.image ? u.image : "/default-avatar.png", 
    };
}

export async function fetchLikes(
    filter?: string,
    opts?: { limit?: number; offset?: number }
): Promise<LikesResponse> {
    try {
        const res = await api.get("/users/likes", {
            params: {
                ...(filter ? { filter } : {}),
                ...(opts?.limit != null ? { limit: opts.limit } : {}),
                ...(opts?.offset != null ? { offset: opts.offset } : {}),
            },
        });

        const data = un(res);

        data.items = (data.items || []).map(normalizeLike);

        if (import.meta.env.VITE_PWA_DEV === "true") {
            console.debug("[likes:fetch] ok:", {
                filter,
                limit: opts?.limit,
                offset: opts?.offset,
                got: data.items?.length,
                total: data.total,
                has_more: data.has_more,
            });
        }

        return data;
    } catch (e: any) {
        if (import.meta.env.VITE_PWA_DEV === "true") {
            console.error("[likes:fetch] fail:", e?.response?.status, e?.response?.data || e);
        }
        throw e;
    }
}

export async function fetchNewLikes(): Promise<LikesResponse> {
    try {
        const res = await api.get("/users/new-likes");

        const data = un(res);

        const items = data.items || data.users || [];

        const normalized = items.map(normalizeLike);

        if (import.meta.env.VITE_PWA_DEV === "true") {
            console.debug("[likes:fetchNew] ok:", normalized.length);
        }

        return {
            items: normalized,
        };
    } catch (e: any) {
        if (import.meta.env.VITE_PWA_DEV === "true") {
            console.error(
                "[likes:fetchNew] fail:",
                e?.response?.status,
                e?.response?.data || e
            );
        }
        throw e;
    }
}

